
































import TopBar from "@/components/common/TopBar.vue";
import StaticTable from "@/components/table/StaticTable.vue";
import Widget from "@/components/common/Widget.vue";
import VerticalStackBar from "@/components/charts/VerticalStackBar.vue";
import VerticalLineAndBarGroupChart from "@/components/charts_js/VerticalLineAndBarGroupChart.vue";
import VerticalLineAndBarSingleChart from "@/components/charts_js/VerticalLineAndBarSingleChart.vue";
import SmallPie from "@/components/charts/SmallPie.vue";
import MultiHorizontalBar from "@/components/charts/MultiHorizontalBar.vue";
import Vue from "vue";
import store from "../../store";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
import {
  callCalc,
  callPrevCalc,
  callYearsums,
  callPlan,
} from "../../helper/utils";
import api from "../../api";
import lodash from "lodash";

import KostenGesamtVergleich from "@/components/DashboardItems/KostenGesamtVergleich.vue";
import Top5KostenbereichePieChart from "@/components/DashboardItems/Top5KostenbereichePieChart.vue";
import Kostenbereiche from "@/components/DashboardItems/Kostenbereiche.vue";
import KostenUndUmsaetze from "@/components/DashboardItems/KostenUndUmsaetze.vue";
import Top5Kostenbereiche from "@/components/DashboardItems/Top5Kostenbereiche.vue";
import Top10KostenBereiche from "@/components/DashboardItems/Top10KostenBereiche.vue";

@Component({
  components: {
    TopBar,
    Widget,
    StaticTable,
    VerticalStackBar,
    VerticalLineAndBarGroupChart,
    VerticalLineAndBarSingleChart,
    SmallPie,
    MultiHorizontalBar,
    KostenGesamtVergleich,
    Top5KostenbereichePieChart,
    Kostenbereiche,
    KostenUndUmsaetze,
    Top5Kostenbereiche,
    Top10KostenBereiche,
  },
})
export default class Kostenanalyse extends Vue {
  initPage = false;

  get planSelected() {
    return store.getters.planSelected;
  }

  get topBarData() {
    return {
      year: store.getters.selectedYear,
      client: store.getters.selectedClient,
    };
  }

  get prevCalcs() {
    return store.getters.previousCalcs;
  }

  get currentCalcs() {
    return store.getters.currentCalcs;
  }

  get calculationPlan() {
    return {
      data: store.getters.currentCalcs,
    };
  }

  get topBarNavigation() {
    return {
      year: store.getters.selectedYear,
      client: store.getters.selectedClient,
      rangeStep: store.getters.rangeStep,
      comparison: store.getters.planSelected,
    };
  }

  get biAgency() {
    return store.getters.selectedBiAgency;
  }

  pushStateHistory(
    stb: any,
    mandant: any,
    year: any,
    range: any,
    comparison: any
  ) {
    const selectedStb = this.biAgency != null ? this.biAgency : stb;

    let path =
      "/" +
      this.$route.name +
      "/" +
      encodeURIComponent(selectedStb) +
      "/" +
      encodeURIComponent(mandant) +
      "/" +
      encodeURIComponent(year) +
      "/" +
      encodeURIComponent(range) +
      "/" +
      encodeURIComponent(comparison);

    if (this.$route.path !== path) {
      this.$router.replace(path);
    }
  }

  loadFromPlan() {
    let client = JSON.parse(String(localStorage.getItem("client")));
    let year = JSON.parse(String(localStorage.getItem("year")));
    api
      .getPlanData(client, year)
      .then((res: any) => {
        store.dispatch("updateLoading", store.state.loading - 1);
        let prevData = null;
        if (this.prevCalcs) {
          prevData = lodash.cloneDeep(this.prevCalcs);
        } else {
          prevData = { BWA: lodash.cloneDeep(this.currentCalcs["BWA"]) };
        }
        if (res && res.data) {
          if (prevData) {
            prevData["BWA"] = res.data.plan_month;
          }
        } else {
          if (prevData) {
            const l = prevData["BWA"]["legend"];
            for (var i = 0; i < l.length; i++) {
              prevData["BWA"]["total"][l[i][0]] = 0;
              for (var month = 1; month < 13; month++) {
                prevData["BWA"][month][l[i][0]] = 0;
              }
            }
          }
        }
        store.dispatch("updatePreviousCalcs", prevData);
      })
      .catch((err) => {
        store.dispatch("updatePreviousCalcs", null);
        store.dispatch("updateLoading", store.state.loading - 1);
      });
  }

  @Watch("topBarData")
  onTopBarDataChange() {
    if (this.topBarData.year && this.topBarData.client) {
      if (!store.getters.isCalcCalled) {
        callCalc();
      }
      if (!store.getters.isPrevCalcCalled && !store.getters.planSelected) {
        callPrevCalc();
      }
      if (store.getters.planSelected) {
        callPlan(store.getters.selectedYear[0]);
      }
      if (!store.getters.isYearsumsCalled) {
        callYearsums();
      }

      if (this.initPage) {
        this.onTopBarNavigationChange();
        this.initPage = false;
      }
    }
  }

  @Watch("topBarNavigation")
  onTopBarNavigationChange() {
    // change URL based on seleted parameters in top bar
    let mandant: string = this.topBarNavigation.client[1];
    let year: string = this.topBarNavigation.year[0];
    let stb: string =
      this.topBarNavigation.client && this.topBarNavigation.client[0];
    this.pushStateHistory(
      stb,
      mandant,
      year,
      store.getters.rangeStep,
      store.getters.planSelected ? "planjahr" : "vorjahr"
    );
  }

  @Watch("calculationPlan")
  loadPlan() {
    let initPlan = JSON.parse(String(localStorage.getItem("initPlan")));
    if (initPlan) {
      this.loadFromPlan();
      localStorage.setItem("initPlan", JSON.stringify(false));
    }
  }

  mounted() {
    this.initPage = true;
    this.onTopBarDataChange();
    if (localStorage.getItem("from") == "kosten_table") {
      (document.getElementById("kosten_table") as any).scrollIntoView();
      localStorage.removeItem("from");
    }
  }
}
